import { Paper, Typography } from '@mui/material';
import {
  BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Legend,
} from 'recharts';
import { formatDate } from '../utils';

const ContractsChart = ({ data }) => (
  <Paper sx={{ p: 2.5, mb: 3 }}>
    <Typography variant="h6" sx={{ fontWeight: 600, mb: 2, color: '#0d3c61' }}>Contracts Over Time</Typography>
    <ResponsiveContainer width="100%" height={350}>
      <BarChart data={data}>
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis dataKey="date" tickFormatter={formatDate} fontSize={11} />
        <YAxis fontSize={11} />
        <Tooltip labelFormatter={(v) => new Date(v).toLocaleDateString()} />
        <Legend />
        <Bar dataKey="total" name="Created" fill="#0d3c61" radius={[4, 4, 0, 0]} />
        <Bar dataKey="viewed" name="Viewed" fill="#ff9800" radius={[4, 4, 0, 0]} />
        <Bar dataKey="signed" name="Signed" fill="#4caf50" radius={[4, 4, 0, 0]} />
      </BarChart>
    </ResponsiveContainer>
  </Paper>
);

export default ContractsChart;
